export default __webpack_public_path__ + "static/media/search.1d92f967.png";